<template>
    <div class="text-right btngroup top_buttons global_components">
        <button type="button" class="btn deleteBtn btn-secondary btn-lg" @click="DeleteFunction"> Delete </button>
        <button type="button" class="btn addBtn ml-3" @click="AddFunction"> Create </button>
    </div>
</template>
<script>
export default {
    props: {
        deleteHandler: {
            type: Function,
            default: () => { }
        },
        createHandler: {
            type: Function,
            default: () => { }
        },
    },
    methods:{
        DeleteFunction(){
            this.deleteHandler()
        },
        AddFunction(){
            this.createHandler()
        },
    }
}
</script>
<style lang="scss" scoped>
    .top_buttons {
        background-color: #00000029;
        padding: 5px 10px;
        border-radius: 5px;
        margin-bottom: 20px;
    }
</style>